import { Form } from 'antd';
import FormItem from 'components/form/FormItem';
import FormUpload, { IFormUploadProps } from 'components/form/FormUpload';
import { useRestContext } from 'components/form/RestInputContext';
import { get } from 'lodash';

export default function RestFormUpload(props: Omit<IFormUploadProps, 'form'>) {
  const { form } = useRestContext();
  return (
    <>
      <Form.Item
        noStyle
        shouldUpdate={(o, n) => {
          return get(o, props.name) !== get(n, props.name);
        }}
      >
        {({ getFieldValue }) => {
          const value = getFieldValue(props.name);
          return <FormUpload {...props} form={form} value={value} />;
        }}
      </Form.Item>
      <div className="d-none">
        <FormItem name={name} />
      </div>
    </>
  );
}
